import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { useTranslation } from "@/hooks/useTranslation";
import { AdminTeamDTO, AdminTeamUserDTO } from "@shaarp/common";
import { useEffect, useState } from "react";
import { Skeleton } from "../ui/skeleton";

export default function DataTableCellAdminReferral({
  team,
  users,
  loading,
}: {
  team: AdminTeamDTO;
  users: AdminTeamUserDTO[];
  loading: boolean;
}) {
  const { t } = useTranslation();

  const [user, setUser] = useState<AdminTeamUserDTO | null>(null);

  useEffect(() => {
    const init = async () => {
      setUser(users.find((u) => u.id === team.invitedBy) ?? null);
    };
    init();
  }, [team.invitedBy, users]);

  if (!team.invitedBy) {
    return null;
  }

  if (loading) {
    return <Skeleton className="w-8 h-8" />;
  }

  if (!user) {
    return (
      <div className="flex items-center">
        <Avatar className="w-8 h-8">
          <AvatarFallback className="text-xs">
            {team.invitedBy.slice(0, 2).toUpperCase()}
          </AvatarFallback>
        </Avatar>
        <span className="ml-2 text-muted-foreground text-sm">
          {t("team.knowledge.dataTable.unknownUser")}
        </span>
      </div>
    );
  }

  return (
    <div className="flex items-center">
      <Avatar className="w-8 h-8">
        <AvatarImage src={user.imageUrl} alt={user.fullName} />
        <AvatarFallback className="text-xs">
          {user.fullName
            .split(" ")
            .map((n) => n[0])
            .join("")
            .toUpperCase()
            .slice(0, 2)}
        </AvatarFallback>
      </Avatar>
      <span className="ml-2 text-sm">{user.fullName}</span>
    </div>
  );
}
